import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=f754160a&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=js"
export * from "./ActionButton.vue?vue&type=script&lang=js"
import style0 from "./ActionButton.vue?vue&type=style&index=0&id=f754160a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f754160a",
  null
  
)

export default component.exports